<template>
 <div class="row">
    <div class="col-xl-12 col-xs-12 vcenter" >
      <div class="form-middle" v-if="!loader">
        <div class="title-form">
            <h1>Hello there</h1>
            <span class="bigger" v-if="!lookup"> Create an account </span>
            <span class="bigger" v-if="lookup">Create an account to find your record</span>
        </div>
        <div>
          <div class="w-form">
            <form id="email-form" @submit.prevent="register" name="email-form" data-name="Email Form">
              <flash-message></flash-message>
              <div class="field">
                <input type="text" v-model="form.full_name" placeholder="enter your full name" class="input-form" required>
                <label for="email">Full Name</label>
              </div>
              <div class="field">
                <input type="email" v-model="form.email" placeholder="name@example.com" class="input-form" required>
                <label for="email">Email Address</label>
              </div>
              <div class="field">
                <input type="password" v-model="form.password" placeholder="Password" class="input-form" required>
                <label for="password">Password</label>
              </div>
              <div class="field">
                <input type="password" v-model="form.repeat_password" placeholder="Re-type Password" class="input-form" required>
                <label for="password">Re-type Password</label>
              </div>
              <div>
                <input type="checkbox"  id="agreementCheckbox"  required>
                <label for="agreementCheckbox">I agree to Orbitly.io's <a href="https://www.orbitly.io/terms-and-conditions" target="_blank">Terms of Service</a> and <a href="https://www.orbitly.io/privacy-policy" target="_blank">Policy</a>. </label>
              </div>
              <br>
              <input type="hidden" id="bypass" ref="bypass">
              <input type="submit" value="Sign up" class="btn btn-large">
              </form>
              <ButtonGoogleOauth title="Sign up with Google" />
              <div class="form-down-content">
                Already have an account? <router-link to="/user/login" class="register-link"> Login </router-link>
              </div>
          </div>
        </div>
      </div>
      <div v-if="loader">
        <div class="spinner">
            <div class="double-bounce1"></div>
            <div class="double-bounce2"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Vue from 'vue'
import ButtonGoogleOauth from '../components/ButtonGoogleOauth'
import { mapMutations } from 'vuex'

export default {
  name: 'login',
  mounted () {
    if (this.authenticated && this.user_data.email_verified) {
      this.$router.push({ name: 'upload_leads' })
    }
    var lookup = this.$route.query.lookup
    if (lookup) {
      this['user/setLookup'](lookup)
    }
    this.messageStorage.destroyAll()
    if (this.lookup && !this.$route.query.lookup) {
      this.$router.push({ name: 'register', query: { lookup: this.lookup } })
    }
  },
  components: {
    ButtonGoogleOauth
  },
  data () {
    return {
      form: {
        full_name: '',
        email: '',
        password: '',
        repeat_password: '',
        bypass:'false'
      },
      messageStorage: this.flash()
    }
  },
  methods: {

    ...mapMutations([
      'user/setAuthUser',
      'user/changeLoaderState',
      'user/setLookup'
    ]),

    register: function () {
      if (this.form.password !== this.form.repeat_password) {
        this.messageStorage.destroyAll()
        this.messageStorage.flash('The password does not match', 'error')
        return
      }
      this['user/changeLoaderState'](true)
      if (this.lookup) {
        this.form['lookup'] = this.lookup
      }
      this.$http.post('/api/user/register', this.form).then((res) => {
        this.messageStorage.destroyAll()
        // this.messageStorage.flash(res.data.message, 'success')
        this['user/setAuthUser'](res.data)
        Vue.http.headers.common['Authorization'] = 'Bearer ' + res.data.access_token
        this.form = {
          full_name: '',
          email: '',
          password: '',
          repeat_password: ''
        }
        this['user/changeLoaderState'](false)
        dataLayer.push({
            'transactionId': Date.now() / 1000 | 0,
            "event" : "leadComplete",
        });
        if (this.lookup) {
          this.$router.push({ name: 'lookup', query: { lookup: this.lookup } })
        } else {
          this.$router.push({ name: 'upload_leads' })
        }
      }).catch((err) => {
        if(err.data.bypass !== undefined) if(err.data.bypass === "true") this.form['bypass'] = "true"
        this.messageStorage.destroyAll()
        this.messageStorage.flash(err.data.error, 'error')
        // this.form.password = ""
        this['user/changeLoaderState'](false)
      })
    }
  },
  computed: {
    loader: function () {
      return this.$store.state.user.loader
    },
    lookup: function () {
      return this.$store.state.user.lookup
    },
    authenticated: function () {
      return this.$store.state.user.authenticated
    },
    user_data: function () {
      return this.$store.state.user.data
    }
  }
}
</script>

<style lang="scss">

.se {
  color: red;
}

</style>
